import React from "react";
import { motion } from "framer-motion";
import { MODAL } from "../../motion/transitions";

const VARIANT_MAP = {
  scaleFade: MODAL.scaleFade,
  scaleFadeClimax: MODAL.scaleFadeClimax,
  slideUp: MODAL.slideUp,
};

function ModalAnimationWrapper({
  children,
  className,
  variant = "scaleFade",
}) {
  const motionVariant = VARIANT_MAP[variant] || MODAL.scaleFade;
  const enterTransition =
    motionVariant.transitionEnter || motionVariant.transition;
  const exitTransition =
    motionVariant.transitionExit || motionVariant.transition;

  return (
    <motion.div
      className={className}
      variants={{
        hidden: motionVariant.initial,
        visible: {
          ...motionVariant.animate,
          transition: enterTransition,
        },
        exit: {
          ...motionVariant.exit,
          transition: exitTransition,
        },
      }}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      {children}
    </motion.div>
  );
}

export default ModalAnimationWrapper;
